import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RootState } from "../app/store";
import { getAvatarImagePath } from "../utils/utility";
import { BalanceRowDisplay } from "keycloakauthmodule";
import { FaRegUserCircle, FaWallet, FaHistory, FaSignOutAlt } from "react-icons/fa";

// Styled Components
const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  position: relative;
`;

const Avatar = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
`;

const DropdownMenu = styled.ul<{ visible: boolean }>`
  position: absolute;
  top: 110%;
  right: 0;
  display: ${(props) => (props.visible ? "block" : "none")};
  background-color: #013a44;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.2);
  list-style: none;
  padding: 0;
  margin: 0;
  width: 200px;
  z-index: 1000;
`;

const DropdownItem = styled.li`
  border-bottom: 1px solid #409dcc;

  &:last-child {
    border-bottom: none;
  }

  a, button {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 16px;
    background: none;
    border: none;
    width: 100%;
    color: white;
    text-align: left;
    cursor: pointer;
    font-size: 14px;
    font-family: Verdana;

    &:hover {
      background-color: #025665;
    }

    text-decoration: none;
  }
`;

interface UserHeaderButtonProps {
  onPageClick: (page: string) => void;
}


const UserHeaderButton: React.FC<UserHeaderButtonProps> = ({ onPageClick }) => {
  const user = useSelector((state: RootState) => state.authSlice.user);
  const navigate = useNavigate();

  const pic =
    user?.userImage && user.userImage.trim().length > 1
      ? user.userImage
      : getAvatarImagePath();

  const dropdownRef = useRef<HTMLUListElement>(null);
  const [showDropdown, setShowDropdown] = useState(false);

  const handleAvatarClick = () => setShowDropdown((prev) => !prev);

  const handleClickOutside = (e: MouseEvent | Event) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(e.target as Node)
    ) {
      setShowDropdown(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const logoutUser = () => {
    localStorage.clear();
    sessionStorage.clear();
    setShowDropdown(false);
    navigate("/");
  };

  return (
    <Wrapper>
      <BalanceRowDisplay currencies={["vpc", "usdc"]} />
      <div>
        <Avatar src={pic} alt="User Avatar" onClick={handleAvatarClick} />
        <DropdownMenu visible={showDropdown} ref={dropdownRef}>
          <DropdownItem>
            <button onClick={() => { setShowDropdown(false); onPageClick("profile"); }}>
              <FaRegUserCircle />
              Profile
            </button>
          </DropdownItem>
          <DropdownItem>
            <button onClick={() => { setShowDropdown(false); onPageClick("account"); }}>
              <FaWallet />
              Account
            </button>
          </DropdownItem>
          <DropdownItem>
            <button onClick={() => { setShowDropdown(false); onPageClick("transactions"); }}>
              <FaHistory />
              Transactions
            </button>
          </DropdownItem>
                    <DropdownItem>
            <button onClick={() => { setShowDropdown(false); onPageClick("history"); }}>
              <FaHistory />
              Box History
            </button>
          </DropdownItem>
          <DropdownItem>
            <button onClick={logoutUser} className="text-danger">
              <FaSignOutAlt />
              Logout
            </button>
          </DropdownItem>
        </DropdownMenu>
      </div>
    </Wrapper>
  );
};

export default UserHeaderButton;
